import { render, staticRenderFns } from "./StandardKeyboard.vue?vue&type=template&id=058e5b5e"
import script from "./StandardKeyboard.vue?vue&type=script&lang=js"
export * from "./StandardKeyboard.vue?vue&type=script&lang=js"
import style0 from "./StandardKeyboard.vue?vue&type=style&index=0&id=058e5b5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports